import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "modal", "hubName", "confirmButton", "confirmText", "confirmSpinner",
    "confirmStep", "runningStep", "statusMessage"
  ]

  open(event) {
    const btn = event.currentTarget
    this._hubName = btn.dataset.hubName
    this._url = btn.dataset.generateUrl

    this.hubNameTargets.forEach(el => el.textContent = this._hubName)
    this._resetState()

    if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
      const modal = bootstrap.Modal.getOrCreateInstance(this.modalTarget)
      modal.show()
    } else {
      this.modalTarget.classList.add('show')
      this.modalTarget.style.display = 'block'
      document.body.classList.add('modal-open')
    }
  }

  close() {
    if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
      const modal = bootstrap.Modal.getInstance(this.modalTarget)
      if (modal) modal.hide()
    } else {
      this.modalTarget.classList.remove('show')
      this.modalTarget.style.display = 'none'
      document.body.classList.remove('modal-open')
      document.querySelector('.modal-backdrop')?.remove()
    }
  }

  async confirm() {
    this.confirmTextTarget.classList.add("d-none")
    this.confirmSpinnerTarget.classList.remove("d-none")
    this.confirmButtonTarget.disabled = true

    try {
      const response = await fetch(this._url, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
          "Accept": "text/html"
        }
      })

      if (response.ok || response.redirected) {
        this._showRunning(`Idea generation queued for ${this._hubName} — new ideas will appear on the Ideas page shortly.`)
      } else {
        this._showRunning("Something went wrong. Please refresh and try again.", { error: true })
      }
    } catch {
      this._showRunning("Could not reach the server. Check your connection and try again.", { error: true })
    }
  }

  _showRunning(message, { error = false } = {}) {
    this.confirmStepTarget.classList.add("d-none")
    this.runningStepTarget.classList.remove("d-none")
    this.statusMessageTarget.textContent = message

    if (error) {
      const icon = this.runningStepTarget.querySelector(".bi-lightbulb")
      icon?.classList.replace("bi-lightbulb", "bi-exclamation-triangle-fill")
      icon?.classList.replace("text-warning", "text-danger")
    }
  }

  _resetState() {
    this.confirmStepTarget.classList.remove("d-none")
    this.runningStepTarget.classList.add("d-none")

    this.confirmTextTarget.classList.remove("d-none")
    this.confirmSpinnerTarget.classList.add("d-none")
    this.confirmButtonTarget.disabled = false

    const icon = this.runningStepTarget.querySelector(".bi-exclamation-triangle-fill")
    icon?.classList.replace("bi-exclamation-triangle-fill", "bi-lightbulb")
    icon?.classList.replace("text-danger", "text-warning")
  }
}
